enum CreatedNftsForAddressStatusToggle {
  All = "all",
  Auction = "auction",
  BuyNow = "buy-now",
}

export default CreatedNftsForAddressStatusToggle;
